import RpcService    from '@/core/services/Rpc/RpcService';
import RpcResponse   from '@/core/services/Rpc/RpcResponse';
import Comment       from '@/core/services/Comments/Comment';
import EntityPointer from '@/domains/EntityPointer/EntityPointer';
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";

/**
 * DAO для работы с комментариями
 */
class CommentsDAO {

	/**
	 * Загружает список комментариев для сущности.
	 * Доступен только админам (см. CommentsController::getListAction).
	 */
	static async getList(
		filters: {
      parentEntity: EntityPointer,
    },
		showLoader = false,
    pagination?: Partial<RpcDataPagination>,
    sort?: Partial<RpcDataSort>,
    onError?: (error: Error) => void,
	): Promise<RpcResponse> {
    return await RpcService.makeRequest(
			'comments.getList',
      filters,
			pagination,
      sort,
      showLoader,
      null,
      onError
		);
	}

	/**
	 * Создаёт комментарий
	 */
	static async add(comment: Comment, showLoader = false): Promise<RpcResponse> {
		return await RpcService.makeRequest('comments.add', { comment }, null, null, showLoader);
	}

	/**
	 * Обновляет комментарий (только автор, в течение 25 минут после создания)
	 */
	static async update(comment: Comment, showLoader = false): Promise<RpcResponse> {
		return await RpcService.makeRequest('comments.update', { comment }, null, null, showLoader);
	}

	/**
	 * Удаляет комментарий (только автор, в течение 25 минут после создания)
	 */
	static async delete(id: number, showLoader = false): Promise<RpcResponse> {
		return await RpcService.makeRequest('comments.delete', { id }, null, null, showLoader);
	}

	/**
	 * Помечает один комментарий прочитанным для текущего пользователя
	 */
	static async markAsRead(comment: Comment, showLoader = false): Promise<RpcResponse> {
		return await RpcService.makeRequest('comments.markAsRead', { comment }, null, null, showLoader);
	}

	/**
	 * Помечает все комментарии сущности прочитанными для текущего пользователя
	 */
	static async markAllAsRead(parentEntity: EntityPointer, showLoader = false): Promise<RpcResponse> {
		return await RpcService.makeRequest('comments.markAllAsRead', { parentEntity }, null, null, showLoader);
	}
}

export default CommentsDAO;
